import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsSoftwarePolicyConflictsRoute: InvariantJiraRoute = {
	name: 'project-settings-software-policy-conflicts',
	path: '/jira/software/projects/:projectKey/settings/policies/conflicts/:entityType',
	exact: true,
	query: ['sourceEntityId?'],
};
